/**
 * Query-param key that carries the AI product draft id through `/ai-listing` URLs.
 * The `[[...draftId]].page.tsx` route reads this exact key (and redirects home when it is
 * missing), so every place that builds or reads the URL must use this constant.
 */
export const AI_PRODUCT_DRAFT_ID_PARAM = 'aiProductDraftId';
